var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "title" }, [_vm._v("卡积分购买")]),
    _vm._v(" "),
    _c("div", { staticClass: "balance" }, [
      _c("span", { staticClass: "text-1" }, [_vm._v("当前积分：")]),
      _c("span", { staticClass: "text-2" }, [
        _vm._v(" " + _vm._s(_vm.stockInfo.balance))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "list" }, [
      _c("div", { staticClass: "list-title" }, [_vm._v("积分购买")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        _vm._l(_vm.packageList, function(item, key) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "box-item",
              class: _vm.packageID == item.id ? "active" : "",
              on: {
                click: function($event) {
                  return _vm.checkPackage(item)
                }
              }
            },
            [
              _c("div", { staticClass: "text-1" }, [
                _c("span", [_vm._v(_vm._s(item.integral))]),
                _c("span", [_vm._v("积分")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-2" }, [
                _vm._v(_vm._s(item.price) + "元")
              ])
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn", on: { click: _vm.createOrder } }, [
      _vm._v("购买")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d533610", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d533610","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cardbalance.vue
// module id = null
// module chunks = 